import type { RuntimeState } from '@/workflow-builder/_contract/runtime';

export function withClearedSelection(state: RuntimeState): RuntimeState {
    return {
        ...state,
        selectionState: {
            selectedToolStep: null,
            selectedInputRoleName: null,
        },
    };
}
